<header class="sidebar-header">
  @if (whitelabelService.whitelabel) {
    @if (!isWhitelabel()) {
      @if (currentUser && !isCurrentUserHidden()) {
        <a [routerLink]="shouldShowHeaderActions() ? '/' : null" class="brand">
          <img class="squareLogo" src="assets/autentique-logo.svg" alt="" />
        </a>
      } @else {
        <a [attr.href]="shouldShowHeaderActions() ? 'https://autentique.com.br' : null" class="brand brand-large">
          <img class="horizontalLogo" src="assets/Autentique.svg" alt="" />
        </a>
      }
    } @else if (whitelabelService.isApplicationWhitelabelLoaded) {
      @if (currentUser && !isCurrentUserHidden()) {
        <a class="brand" style="cursor: default">
          <img class="squareLogo" [src]="whitelabelService.whitelabel.pdf_logo_mini || 'assets/autentique-logo.svg'" alt="" />
        </a>
      } @else {
        <a>
          <img class="horizontalLogo horizontalLogo_logo" [src]="whitelabelService.whitelabel?.logo" alt="" />
        </a>
      }
    }
  }
  @if (currentUser && shouldShowHeaderActions()) {
    @if (urlParamsService.params.menuBackButton) {
      @if (!isCurrentUserHidden() || (!isOnSigningPage() && isWhitelabel() && !isLoading)) {
        <ng-content></ng-content>
      }
    }

    @if (whitelabelService.isApplicationWhitelabelLoaded) {
      @if (!isCurrentUserHidden() && !isWhitelabel() && !isLoading) {
        <app-verifications-credits-count [user]="currentUser" class="mr-1 ml-auto"></app-verifications-credits-count>
        <app-documents-count [user]="currentUser"></app-documents-count>
      }
    }
  }
</header>
